import React, {useState, useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';

import AxiosApiClient from '../utils/AxiosApiClient';
import AuthUtility from './auth/AuthUtility';
import LoadingSpinner from './LoadingSpinner';
import { categories, getMimeType } from '../utils/common';

import PaypalPaymentComponent from './PaypalPaymentComponent';

import swal from 'sweetalert';

const error_style = 'font-source-sans font-size-12 font-weight-500 txt-error bg-error p-5';
const aws_s3_url = `https://video-app-s3-bucket.s3.us-west-1.amazonaws.com`;

function Search(){
	
	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}
  
    // using hooks
    const [isLoading, setIsLoading] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
	const [searchInput, setSearchInput] = useState({
		search_terms: '',
		category_id: 0,
		errorList: [],
		errorStyle: [],
	});
	const [videoList, setVideoList] = useState([
        //{ id: '', category_id: "", title: "", description: "", privacy: "", audience: "", video_file: "", thumbnail_file: "", status: "", views: 0, random_id: "", created: "", updated: "" },
	]);
	const [videoListMessage, setVideoListMessage] = useState(null);
	const [donationInput, setDonationInput] = useState({
		amount: '',
		errorList: [],
		errorStyle: [],
	});
	const [viewMode, setViewMode] = useState('search'); // 'search' | 'video' | 'donate'
	const [selectedVideo, setSelectedVideo] = useState(null);
	const [authRole, setAuthRole] = useState(
		AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
	);
	
	// Initialize Foundation after the component mounts
	useEffect(() => {
		if (isMounted) {

			setViewMode('search');
			setSelectedVideo(null);

		}else {
	      setIsMounted(true);
	    }
		
	}, [isMounted]);

	const handleSearchInput = (event) => {
		event.persist();
		
	    setSearchInput({...searchInput, [event.target.name]: event.target.value });
		
		//remove the target error message no matter the new input, it will be validated on the server
		if (searchInput.errorList.hasOwnProperty(event.target.name)){
			delete searchInput.errorList[event.target.name];
			delete searchInput.errorStyle[event.target.name];
		}
	}
	
	const searchVideosSubmit = (event) => {
		event.preventDefault();
		
		setIsLoading(true);

		//values sent to api
		const payload = {
			search_terms: searchInput.search_terms,
			category_id: searchInput.category_id,
		}

		const fetchApiDataSearchVideos = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/search_videos', payload, {});

				setApiDataSearchVideos(response, "searchVideosSubmit");
			} catch (error) {
				handleApiErrorSearchVideos(error, "searchVideosSubmit");
			}
		};

		fetchApiDataSearchVideos();
	};
	function setApiDataSearchVideos(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				//set data
				if(response.data.videos && response.data.videos.length > 0){
					setVideoList(response.data.videos);
					setVideoListMessage(null);
				}else{
					setVideoList([]);
					setVideoListMessage('No Videos Exists');
				}

			} else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//set data
				if(response.data.videos && response.data.videos.length > 0){
					setVideoList(response.data.videos);
					setVideoListMessage(null);
				}else{
					setVideoList([]);
					setVideoListMessage('No Videos Exists');
				}

			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

				var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
				Object.keys(errorStyleTemp).map((key) => (
					errorStyleTemp[key] = error_style
				));
				
				//validation errors mapped to input fields
				setSearchInput({...searchInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });

			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiErrorSearchVideos(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		setIsLoading(false);
		swal("Error", error, "error");
	}

	const handleOpenVideoView = (event, video) => {
		event.preventDefault();

		setViewMode('video');
		setSelectedVideo(video);
		updateVideoViews(video);
		
	};
	
	function handleCloseVideoView(){

		setViewMode('search');
		setSelectedVideo(null);
	}

	function updateVideoViews(video) {

		//values sent to api
		const payload = {
			video_random_id: video.random_id,
		}

		const fetchApiDataUpdateVideoViews = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/update_video_views', payload, {});

				setApiDataUpdateVideoViews(response, "updateVideoViews");
			} catch (error) {
				handleApiErrorUpdateVideoViews(error, "updateVideoViews");
			}
		};

		fetchApiDataUpdateVideoViews();
	};
	function setApiDataUpdateVideoViews(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				setVideoList((prevVideoList) => {
					return prevVideoList.map((video) =>
					  video.random_id === response.data.video.random_id ? response.data.video : video
					);
				});

			} else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');
			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');
			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiErrorUpdateVideoViews(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		setIsLoading(false);
		swal("Error", error, "error");
	}
	const handleOpenDonationView = (event, video) => {
		event.preventDefault();

		setViewMode('donation');
		setSelectedVideo(video);
		updateVideoViews(video);
		
	};
	function handleCloseDonationView(){

		setViewMode('search');
		setSelectedVideo(null);
	}
    
  	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>
			
		{viewMode === 'search' && (
			<div className="panel large ptb-20l-10s">
				<form onSubmit={searchVideosSubmit}>
				<div className="grid-x">
					<div className="large-7 medium-7 small-5 cell text-left pr-5">
						<span className={searchInput.errorStyle.search_terms}>{searchInput.errorList.search_terms}</span>
						<input type="text" name="search_terms" onChange={handleSearchInput} value={searchInput.search_terms} className="input-group-fieldx mt-10" placeholder='Search Terms'/>
					</div>
					<div className="large-4 medium-3 small-4 cell text-left pr-5">
						<span className={searchInput.errorStyle.category_id}>{searchInput.errorList.category_id}</span>
						<select name="category_id" onChange={handleSearchInput} value={searchInput.category_id}>
							<option key={0} value={0}>All Categories</option>
							{categories.map((category, i) => (
							<option key={category.id} value={category.id}>{category.title}</option>
							))}
						</select>
					</div>
					<div className="large-1 medium-2 small-3 cell text-right">
						<button type="submit" className="button width-auto uppercase">Search</button>
					</div>
					
					<div className="large-12 medium-12 small-12 cell text-left pt-20">
						<div className="font-orbitron font-size-24 font-weight-800 bb1-555 uppercase italic pb-5">Videos</div>
					</div>
				</div>
				</form>
				
				<div className="grid-x">
					{videoList.length > 0  ? (
					<div className="large-12 medium-12 small-12 cell">
        				<div id="video_list" className="grid-x grid-margin-x z-index-0">
				          {videoList.map((video, i) => (
				            <div key={'no_edit_' + video.id + video.random_id} className="large-3 medium-4 small-12 cell pt-10">
				              <div className="video-content-wrapper p-10 bg-fafafa b1-ccc br-3 text-center">
				                <Link onClick={(e) => handleOpenVideoView(e, video)} className="font-small text-center no-underline hover-opacity-50" valign="top">
				                	<div className="font-source-sans font-size-16 font-weight-600 txt-333 pb-5 video-content" valign="top">
				                    	{video.title}
				                	</div>
				                	<img src={aws_s3_url + '/' + video.thumbnail_url} alt="Video thumbnail" width={250} />
				                	<div className="font-source-sans font-size-16 font-weight-600 txt-333 p-5 justify video-content" valign="top">
				                    	{video.description}
				                	</div>
				                </Link>
								{video.paypal_email && video.paypal_merchant_id ? (
				                <div className="video-donate-button text-center pt-10">
					                <Link onClick={(e) => handleOpenDonationView(e, video)} className="button uppercase">Donate</Link>
				                	<div className="font-source-sans font-size-16 font-weight-400 txt-000 pt-10 text-center video-content" valign="top">
				                    	{video.views}&nbsp;&nbsp;views
				                	</div>
					          	</div>
								) :(
				                <div className="video-donate-button text-center pt-10">
				                	<div className="font-source-sans font-size-16 font-weight-400 txt-000 text-center video-content" valign="top">
				                    	{video.views}&nbsp;&nbsp;views
				                	</div>
					          	</div>
								)
								}
				              </div>
				            </div>
						))}
						</div>
					</div>
					) : (
					<div id="video_list" className="large-12 medium-12 small-12 cell pt-5 font-source-sans font-size-16">{videoListMessage}</div>
					)}
					
					{isLoading && 
					<div className="large-12 medium-12 small-12 cell text-center">
					<LoadingSpinner paddingclassName="p-20l-10s" />
					</div>
					}
					
				</div>
			</div>
			)}
			{viewMode === 'video' && (
			<div className="panel large ptb-20l-10s video-panel">
				<div className="grid-x">
					<div className="large-5 medium-5 small-5 cell font-source-sans font-size-16 font-weight-600 txt-333 text-left">
						{selectedVideo.title}
					</div>
					<div className="large-2 medium-2 small-2 cell text-center">
						{selectedVideo.paypal_email &&
						<div className="video-donate-button text-center">
							<Link onClick={(e) => handleOpenDonationView( e, selectedVideo)} className="button tiny uppercase">Donate</Link>
						</div>
						}
					</div>
					<div className="large-5 medium-5 small-5 cell text-right">
					    <Link onClick={handleCloseVideoView} className="button tiny uppercase">Close</Link>
					</div>
					<div className="large-12 medium-12 small-12 cell pt-10 video-container">
						<div className="video-wrapper">
							<video controls>
								<source src={aws_s3_url + '/' + selectedVideo.video_url} type={getMimeType(selectedVideo.video_url)} />
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
				</div>
			</div>
			)}
			{viewMode === 'donation' && (
			<div className="panel large ptb-20l-10s video-panel">
				<div className="grid-x">
					<div className="large-6 medium-9 small-9 cell font-source-sans font-size-16 font-weight-600 txt-333 text-left">
					</div>
					<div className="large-6 medium-3 small-3 cell text-right">
					    <Link onClick={handleCloseDonationView} className="button tiny uppercase">Close</Link>
					</div>
				</div>
				<PaypalPaymentComponent video={selectedVideo}/>
			</div>
			)}
		</div>
	);
}

export default Search;
					